<template>
  <section id="main" class="main_section">
    <div class="container_main">
      <div class="container_main_info">
        <div class="box_main_text">
          <h1 class="title_h1">
            <span class="color_orange">ТВОЯ ИДЕАЛЬНАЯ</span><br />
            МЕБЕЛЬ
          </h1>
          <p class="sub_text_main">
            Сочетание красоты и функциональности является для нас естественным
            выбором.<span class="color_orange">Дизайнерская мебель на заказ в<br />
            Санкт-Петербурге.</span>
          </p>
        </div>
        <!-- <div class="container_sub_text_main">
          <div class="box_sub_text_main">
            <img src="@/assets/img/icon/Star.svg" class="star" />
            <p class="sub_text_main_star">
              Реализуем ваши мечты и готовые проекты
            </p>
          </div>
          <div class="box_sub_text_main">
            <img src="@/assets/img/icon/Star.svg" class="star" />
            <p class="sub_text_main_star">Соблюдаем сроки!</p>
          </div>
          <div class="box_sub_text_main">
            <img src="@/assets/img/icon/Star.svg" class="star" />
            <p class="sub_text_main_star">
              Предлагаем широкий выбор материалов и фурнитуры!
            </p>
          </div>
        </div> -->
        <div class="container_href_soc">
          <div class="vertical_line"></div>
          <a href="https://t.me/mebeldl_mng" target="_blank" class="round_button">
            <img src="@/assets/img/icon/tg.png" class="tg_img" />
          </a>
          <a target="_blank" href="https://wa.me/79817167552" class="round_button">
            <img src="@/assets/img/icon/phone.png" class="phone_img" />
          </a>
          <a
            target="_blank"
            href="https://www.avito.ru"
            class="round_button"
          >
            <img src="@/assets/img/icon/vk.png" class="vk_img" />
          </a>
          <div class="vertical_line"></div>
        </div>
      </div>
      <div class="container_bid_first">
        <PhoneUi />
        <a href="tel:89817167552" class="button_phone"
          ><img src="@/assets/img/icon/phone.png" class="icon_phone"
        /></a>
      </div>
    </div>
  </section>
</template>
<script>
import PhoneUi from "./ui/PhoneUi.vue";

export default {
  components: {
    PhoneUi,
  },
};
</script>
<style>
.main_section {
  background-image: url(../assets/img/back/main_back.webp);
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
}
.container_main {
  width: 100%;
  height: 100%;

  display: flex;
  padding: 4rem 0rem 0rem 0rem;
  justify-content: flex-end;
  flex-direction: column;
}
.container_bid_first {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 14rem;
  padding: 4rem 8rem 2rem 8rem;
  background: rgb(16, 13, 10, 0.7);
}
.button_phone {
  background: linear-gradient(
    90deg,
    rgb(245, 160, 62),
    rgb(207, 117, 14) 102.477%
  );
  width: 3rem;
  height: 3rem;
  display: flex;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
}
.icon_phone {
  width: 1.65rem;
  height: 1.55rem;
}
.container_main_info {
  display: flex;
  padding: 0rem 20rem 4rem 8rem;
  position: relative;
  justify-content: space-between;
}
.box_main_text {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  max-width: 40vw;
}
.title_h1 {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 3.2rem;
  font-weight: 700;
  line-height: 3.75rem;
  letter-spacing: 0%;
  text-align: left;
}

.sub_text_main {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.container_sub_text_main {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.star {
  width: 1.2rem;
  height: 1.2rem;
  object-fit: cover;
}
.sub_text_main_star {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  text-transform: uppercase;
}
.box_sub_text_main {
  display: flex;
  gap: 0.5rem;
  width: 14.7rem;
  align-items: flex-start;
}
.vertical_line {
  border-bottom: 0.05rem solid rgb(255, 255, 255);
  transform: rotate(-90deg);
  width: 4rem;
}
.container_href_soc {
  bottom: 8rem;
  right: 8.6rem;
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}
.vertical_line:first-child {
  margin-bottom: 2rem;
}

.vertical_line:last-child {
  margin-top: 2rem;
}

.round_button {
  width: 2rem;
  height: 2rem;
  border: 0.1rem solid rgb(255, 255, 255);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tg_img {
  width: 1rem;
  height: 1rem;
  margin-right: 0.1rem;
}
.phone_img {
  width: 1.1rem;
}
.vk_img {
  width: 1.2rem;
  height: 1.2rem;
}
@media (max-width: 767px) {
  .container_main_info {
    padding: 0rem 2.4rem 2rem 2.4rem;
  }
  .title_h1 {
    font-size: 2.29rem;
    font-weight: 700;
    line-height: 2.71rem;
  }
  .sub_text_main {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
  .container_main_info {
    flex-direction: column;
    gap: 4rem;
  }
  .box_main_text {
    gap: 1.5rem;
    max-width: 100vw;
  }
  .container_href_soc {
    display: none;
  }
  .container_bid_first {
    height: fit-content;
    padding: 3rem 2.4rem 0.8rem 2.4rem;
  }
  .container_sub_text_main {
    align-items: flex-end;
    gap: 0.9rem;
  }
  .box_sub_text_main {
    width: 16.5rem;
  }
  .button_phone {
    width: 2.71rem;
    height: 2.71rem;
    margin-top: 0.5rem;
  }
  .icon_phone {
    width: 1.49rem;
    height: 1.4rem;
  }
}
</style>
